import React, { useState } from "react";
import MuiBox from "../MuiBox";
import MuiTypography from "../MuiTypography";
import { Button } from "@mui/material";
import { closeCenterModal } from "store/slices/CenterModal.slice";
import { useDispatch } from "react-redux";
import SubmitLoaderButton from "../SubmitLoaderButton";

const CancelUploadModal = ({
    title,
    description,
    cancelBtnName,
    continueBtnName,
    onCancelUploads,
    onContinue,
}) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const handleCancelUploads = async () => {
        setLoading(true);
        try {
            await onCancelUploads?.();
            dispatch(closeCenterModal());
        } catch (error) {
            console.error("Cancel uploads failed", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <MuiBox
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                    p: "24px",
                }}
            >
                <MuiTypography fontWeight="600" variant="20" color="text.darkBlack">
                    {title}
                </MuiTypography>
                <MuiTypography fontWeight="400" variant="14" color="text.gray900">
                    {description}
                </MuiTypography>
            </MuiBox>

            <MuiBox
                sx={{
                    display: "flex",
                    gap: "12px",
                    justifyContent: "end",
                    backgroundColor: "background.gray200",
                    p: "16px 24px",
                }}
            >
                {/* Continue uploading → just close the modal */}
                <Button
                    variant="whiteContained"
                    onClick={() => {
                        onContinue?.();
                        dispatch(closeCenterModal());
                    }}
                    disabled={loading}
                >
                    {continueBtnName}
                </Button>

                {/* Cancel uploads → run the abort action */}
                <SubmitLoaderButton
                    variant="contained"
                    btnText={cancelBtnName }
                    isDisable={loading}
                    isLoading={loading}
                    onClick={handleCancelUploads}
                    sx={{
                        width: "fit-content",
                        minWidth: "70px",

                    }}
                />
            </MuiBox>
        </>
    );
};

export default CancelUploadModal;